import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { formatDate } from "../utils/dateUtils";

const STATUS_ASSINATURA = ["PENDENTE", "ATIVA", "CANCELADA"] as const;

const getNomePessoa = (pessoa: any) => {
  const nomeCompleto = [pessoa?.nome, pessoa?.sobrenome]
    .filter((parte) => Boolean(parte))
    .join(" ")
    .trim();

  return nomeCompleto || pessoa?.nome || "";
};

export const assinaturaService = async () => {
  const Token = validateToken();

  if (!Token) {
    return [];
  }

  const URL = `${Globais.DOMINIOBACK}/assinatura/pesquisa/status`;

  try {
    const responses = await Promise.all(
      STATUS_ASSINATURA.map((status) =>
        axios.post(
          URL,
          { status },
          {
            headers: { Authorization: Token.AuthStr },
          }
        )
      )
    );

    const assinaturasBrutas = responses.flatMap((response) =>
      Array.isArray(response.data) ? response.data : []
    );

    const assinaturasUnicas = Array.from(
      new Map(
        assinaturasBrutas.map((assinatura: any) => [assinatura.id, assinatura])
      ).values()
    );

    return assinaturasUnicas
      .sort((a: any, b: any) => {
        const dataA = a?.created_at ? new Date(a.created_at).getTime() : 0;
        const dataB = b?.created_at ? new Date(b.created_at).getTime() : 0;

        return dataB - dataA;
      })
      .map((p: any) => ({
        key: p.id,
        id: p.id,
        pessoaId: p.pessoaId ?? p.PessoaTable?.id ?? null,
        planoAssinatura: p.planoAssinatura ?? "",
        created_at: formatDate(p.created_at),
        dataAssinatura: formatDate(p.dataAssinatura),
        dataVencimento: formatDate(p.dataVencimento),
        status: p.status,
        cotasUsuariosId: p.cotasUsuariosId ?? null,
        active: p.active ?? 1,
        nomeUsuario:
          p.UsuarioTable?.nome ||
          getNomePessoa(p.PessoaTable) ||
          p.nome ||
          `Pessoa ${p.pessoaId ?? p.PessoaTable?.id ?? "-"}`,
        numeroApto: p.CotasUsuariosTable?.numeroApto ?? "-",
        nomeEmpreendimento:
          p.CotasUsuariosTable?.CotaTable?.AptoTable?.EmpreendimentoTable
            ?.nome ?? "Sem cota vinculada",
      }));
  } catch (error) {
    console.log(error);
    return [];
  }
};

export {};
